import { store } from 'src/common/redux/configure-store';
import { getCardData, hasCardData } from 'src/devices/payment/get-card-details';
import {
  findMatchingTenderInStore,
  setSelectedTenderAndGroup,
} from 'src/tendering/business-logic/handle-tender-payment';
import { processTenderAmountEntryOption } from 'src/tendering/business-logic/process-tender-amount-entry-option';

export const processSwipeAheadData = () => {
  if (hasCardData()) {
    const cardDetails = getCardData();
    const tender = findMatchingTenderInStore(cardDetails);
    const { amountDue } = store.getState().itemList;
    if (tender) {
      setSelectedTenderAndGroup(tender);
      processTenderAmountEntryOption(tender, amountDue);
    }
  }
};
